import axiosInstance from '../helpers/axiosInstance'

// Country default campaigns (metrics engine admin surface). The first /api/v2 consumer in WMS: same host, same JWT.
const BASE = `${process.env.REACT_APP_PLATFORM_URL}/api/v2/metrics/default_seasons`

export const fetchDefaultCampaigns = async country => {
  const res = await axiosInstance.get(BASE, { params: { country } })
  return res.data
}

export const createDefaultCampaign = async data => {
  const res = await axiosInstance.post(BASE, data)
  return res.data
}

export const updateDefaultCampaign = async (id, data) => {
  const res = await axiosInstance.patch(`${BASE}/${id}`, data)
  return res.data
}

export const deleteDefaultCampaign = async id => {
  await axiosInstance.delete(`${BASE}/${id}`)
}
